export const components = {
  'Facial recognition': 'Reconocimiento facial',
  Payment: 'Pago',
  Summary: 'Resumen',
};
